import { useEffect, useRef, useState } from 'react';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import * as Icon from '@mui/icons-material/';
import ComponentTable from '../../../Components/Table/Index';
import { Button } from '../../../../shared/components/button/Button';
import { Form, Formik, Field } from 'formik';
import { useNavigate } from 'react-router-dom';
import { Column } from '../../../Components/Table/Types';
import {
  UsuarioAtualizar,
  UsuarioCadastrar,
} from '../../../../routes/RoutesNames';
import { IconButton } from '@mui/material';
import UsuarioController from '../../../../controllers/UsuarioController';
import { Loader } from '../../../../shared/components/Loader';
import { HeaderComponent } from '../../../../shared/components/HeaderComponent';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import { ButtonMenu } from '../../../../shared/components/ButtonMenu';

interface Row {
  BtnEditar?: JSX.Element;
  BtnExcluir?: JSX.Element;
  usu_id?: number;
  usu_nome?: string;
  usu_login?: string;
}

export default function Usuario() {
  const ref = useRef<HTMLButtonElement>(null);
  const navigate = useNavigate();
  const [loading, setLoading] = useState<boolean>(false);
  const usuarioLogado = useSelector((state: any) => state.Authentication.userId);

  const tableColumns: Column[] = [
    // { id: 'BtnEditar', label: '', width: 60, minWidth: 0 },
    // { id: 'BtnExcluir', label: '', width: 60, minWidth: 0 },
    { id: 'Id', label: 'Id', minWidth: 0, align: 'center' },
    { id: 'Nome', label: 'Nome', minWidth: 0 },
    { id: 'Login', label: 'Login', minWidth: 0 },
    { id: 'BtnMenu', label: '', width: 60, minWidth: 0, align: 'right' },
  ];

  const [tableRows, setTableRows] = useState<Row[]>([]);

  useEffect(() => {
    ref?.current?.click();
  }, []);

  const handleNavigation = async (): Promise<void> => {
    navigate(UsuarioCadastrar);
  };

  const handleEditItem = (item: Row, duploClick = false, duploClickId = 0) => {
    if (duploClick) {
      navigate(UsuarioAtualizar.replace(':id', duploClickId.toString()), { state: { duploClick: true } });
    }
    else {
      navigate(UsuarioAtualizar.replace(':id', item.usu_id!.toString()));
    }
  };

  const handleDeleteItem = async (usu_id: number) => {
    //const request: any = { UsuId: usuarioLogado, UsuarioId: usu_id };
    const response = await UsuarioController.Excluir(usu_id);

    if (response.StatusCode === 204) {
      toast('Usuário excluído com sucesso!', {
        type: 'success',
      });
      handleSubmit(initialValues);
    } else {
      toast('Erro ao excluir o usuário!', {
        type: 'error',
      });
    }
    console.log(usu_id);
  };

  const handleSubmit = async (values: any) => {

    const DataRows: any = [];
    setLoading(true);
    const Response = await UsuarioController.Listar(values);
    setLoading(false);
    if (Response.StatusCode === 200 && Response?.Data?.length > 0) {
      Response.Data.map((item: Row) => {
        DataRows.push({
          // BtnEditar: (
          //   <IconButton
          //     onClick={() => handleEditItem(item)}
          //     aria-label='edit'
          //     color='info'
          //     title='Editar'
          //   >
          //     {' '}
          //     <Icon.Edit />
          //   </IconButton>
          // ),
          // BtnExcluir: (
          //   <IconButton
          //     onClick={() => handleDeleteItem(item.usu_id!)}
          //     aria-label='delete'
          //     color='error'
          //     title='Excluir'
          //   >
          //     <Icon.Delete />
          //   </IconButton>
          // ),
          Id: item.usu_id,
          Nome: item.usu_nome,
          Login: item.usu_login,
           BtnMenu: (
                      <ButtonMenu
                        items={[
                          { onClick: () => handleEditItem(item), menu: 'Editar' },
                          {
                            onClick: () => handleDeleteItem(item.usu_id!),
                            menu: 'Excluir', confirmar: `Excluir o usuário "${item.usu_nome ?? ''}"? Esta ação não pode ser desfeita.`,
                          },
                        ]}
                      />
                    ),
        });

        setTableRows(DataRows);
      });
    } else {
      setTableRows([]);
    }
  };

  const initialValues = {
    UsuarioId: null,
    Nome: '',
    Setor: '',
  };

  useEffect(() => {
    handleSubmit(initialValues)
  }, []);

  return (
    <Loader loading={loading}>
      <Box
        sx={{
          '& .MuiTextField-root': { m: 1, width: '35ch' },
        }}
      >
        <div className={'pb-2'}>
          <HeaderComponent
            className={'mb-6'}
            text={'Listagem de Usuários'}
            ButtonRight={
              <Button
                className={''}
                variant='success'
                onClick={handleNavigation}
                iconStart={<Icon.Add />}
                title={'Incluir'}
              />
            }
          />
          <Box mb={2} />
          <Formik
            enableReinitialize={true}
            initialValues={initialValues}
            onSubmit={handleSubmit}
          >
            {({ errors }) => (
              <Form>
                <Box className={'flex flex-row items-center gap-2'}>
                  <Field
                    //required
                    //error
                    classsName={'col-span-8'}
                    name='UsuarioId'
                    as={TextField}
                    label='Código'
                    type='number'
                    autoComplete='current-password'
                    size={'small'}
                    InputLabelProps={{ shrink: true }}
                  />

                  <Field
                    name='Nome'
                    as={TextField}
                    label='Nome'
                    type='text'
                    error={Boolean(errors?.Nome)}
                    helperText={errors?.Nome}
                    size={'small'}
                    InputLabelProps={{ shrink: true }}
                  />
                  <Box>
                    <IconButton size={'large'} type={'submit'}>
                      <Icon.Search style={{ fontSize: '28px' }} />
                    </IconButton>
                  </Box>
                </Box>

              </Form>
            )}
          </Formik>
        </div>
        <ComponentTable columns={tableColumns} rows={tableRows} onRowDoubleClick={(row) => {
          handleEditItem(row, true, row.Id);
        }} />
      </Box>
    </Loader>
  );
}
